import type { SVGProps } from 'react';

const LockUnlocked = (props?: SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.83334 7.83335C3.83334 7.46515 4.13182 7.16669 4.50001 7.16669H11.5C11.8682 7.16669 12.1667 7.46515 12.1667 7.83335V11.5C12.1667 12.2364 11.5697 12.8334 10.8333 12.8334H5.16668C4.4303 12.8334 3.83334 12.2364 3.83334 11.5V7.83335Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.16668 7.00002V6.56231C5.16668 5.74331 5.13397 4.86591 5.61612 4.20387C5.99909 3.67801 6.70455 3.16669 8.00001 3.16669C9.33335 3.16669 10.1667 4.16669 10.1667 4.16669"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LockUnlocked;
